import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const videoAnalysis = createAsyncThunk('videoAnalysis/videoAnalysis', async (data) => {

    try {
        const res = await axios({
            method: 'GET',
            url: process.env.REACT_APP_API_URL + `youtube_analytic_list`,
              params: {
                youtube_link_id: data?.video_id,
              
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${localStorage.getItem("token")}`
            }
        })
        return res
    } catch (error) {
        return error.response || { status: 500, data: { message: 'Network error or timeout' } }
    }
})

const videoAnalysisSlice = createSlice({
    name: 'videoAnalysis',
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    extraReducers: (builder) => {
        builder.addCase(videoAnalysis.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(videoAnalysis.fulfilled, (state, action) => {
            state.loading = false;
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
                state.error = null;
            } else if (action?.payload?.status === 401) {
                state.data = null;
                state.error = 'Unauthorized';
                localStorage.clear();
                action?.meta?.arg?.navigate('../login')
            } else {
                state.error = action.payload?.data?.message || 'Failed to fetch link analysis';
                state.data = null;
            }
        });
        builder.addCase(videoAnalysis.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error?.message || 'An error occurred';
            state.data = null;
        });
    }
})

export default videoAnalysisSlice.reducer;

